import sampleContract from '../assets/Training-Revised-demo-JV-Redline-pdf.pdf';

export const dummyData = [
  {
    chat_history: [],
    chat_id: '1',
    chat_start_time: new Date(),
    clm_id: null,
    document_id: 'document-id-1',
    document_name: 'Joint Venture Agreement',
    pdf_link: sampleContract,
    upload_time: new Date(),
  },
  {
    chat_history: [],
    chat_id: '2',
    chat_start_time: new Date(),
    clm_id: null,
    document_id: 'Sample Contract',
    document_name: 'Sample Contract',
    pdf_link: sampleContract,
    upload_time: new Date(),
  },
];
